import React from 'react';
import ManagementSectionManager, {
  type ManagerFieldDef,
  type ManagerColumnDef,
} from '@/components/ManagementSectionManager';

/**
 * Our Clients manager (management websites only).
 */

const fields: ManagerFieldDef[] = [
  { name: 'name', label: 'Client Name', type: 'text', maxLength: 120, helpText: 'Optional — leave blank for logo-only entries.' },
  {
    name: 'logoUrl',
    label: 'Logo',
    type: 'image',
    aspectRatio: null,
    helpText: 'Optional — works with any logo size or ratio. Without a logo, the client name is shown when provided.',
  },
  { name: 'websiteUrl', label: 'Website URL', type: 'url' },
  { name: 'category', label: 'Category', type: 'text', maxLength: 120, helpText: 'Optional label, e.g. "Events", "Brands", "Venues".' },
];

const columns: ManagerColumnDef[] = [
  {
    name: 'name',
    label: 'Client',
    render: (item) => (
      <div className="flex items-center gap-3">
        {item.logoUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={item.logoUrl} alt="" className="h-7 w-auto max-w-[4.5rem] object-contain shrink-0" />
        ) : (
          <span className="w-10 text-center font-heading text-sm">{item.name?.[0]}</span>
        )}
        <span className="font-medium">{item.name}</span>
      </div>
    ),
  },
  {
    name: 'category',
    label: 'Category',
    render: (item) => <span className="text-muted-foreground">{item.category || '—'}</span>,
  },
];

const ClientsManager: React.FC = () => (
  <ManagementSectionManager
    title="Our Clients"
    description=""
    apiPath="/api/clients"
    sectionKey="clients"
    itemLabel="client"
    fields={fields}
    columns={columns}
    toggleField={{ name: 'isActive' }}
    emptyHint="No clients yet. Add the brands, venues and partners you've worked with."
  />
);

export default ClientsManager;
